import { Locale, Locales } from "@i18n";
import { createContainer } from "awilix";
import { AssaiaUser } from "@shared/components/OIDCApp";

import { ApiClient } from "@api/ApiClient";
import { Api } from "@api";

import { AirportConfigStore } from "@stores/AirportConfigStore";

import { LocalConfigOverrider } from "@services/localConfigOverrider";

export type DIProps = {
  user: AssaiaUser;
  apiClient: ApiClient;
  api: Api;
  config: AirportConfigStore;
  configOverrides: LocalConfigOverrider;
  locale: Locale;
  locales: Locales;
};

export type TDI = typeof di;

//TODO review al usages and try to reduce direct usages and use more injections
export const di = createContainer<DIProps>({ injectionMode: "PROXY" });

export function getConfig() {
  return di.resolve("config");
}

export function getAcdmConfig() {
  const acdmConfig = getConfig().acdm;
  if (!acdmConfig) {
    throw new Error("ACDM config is not defined");
  }
  return acdmConfig;
}
window._di = di;
